import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { GraphComponent } from '@ardoq/yfiles';
import { HeightOffset } from 'views/viewLegend/useViewLegendSubscription';
import { GraphComponentViewLegendProps, ViewLegend } from '@ardoq/view-legend';
import {
  ArdoqGraphComponent,
  ArdoqGraphComponentForwardRefType,
  ArdoqGraphComponentProperties,
} from './graphComponent/ArdoqGraphComponent';
import { ViewLegendContainer } from '@ardoq/graph';
import { omit } from 'lodash';
import { getViewLegendLabels } from 'viewLegend/getViewLegendLabels';
import type { I18nLocale } from '@ardoq/i18n';

export type ArdoqGraphComponentWrapperForwardRefType = {
  graphComponent: React.RefObject<GraphComponent | null> | null;
  graphComponentContainer: React.RefObject<HTMLDivElement | null> | null;
};
const ArdoqGraphComponentWithLegend = forwardRef<
  ArdoqGraphComponentWrapperForwardRefType,
  Omit<ArdoqGraphComponentProperties, 'i18nLocale'> & {
    isLegendActive: boolean;
    legendProps: GraphComponentViewLegendProps;
    i18nLocale: I18nLocale;
  }
>((props, ref) => {
  const graphComponentRef = useRef<ArdoqGraphComponentForwardRefType | null>(
    null
  );

  useImperativeHandle(ref, () => ({
    graphComponent: graphComponentRef.current?.graphComponent ?? null,
    graphComponentContainer:
      graphComponentRef.current?.graphComponentContainer ?? null,
  }));

  const { legendProps, i18nLocale } = props;

  const graphComponentProps = omit(props, ['isLegendActive', 'legendProps']);

  return (
    <>
      <ArdoqGraphComponent ref={graphComponentRef} {...graphComponentProps} />
      <HeightOffset>
        {heightOffset => (
          <ViewLegendContainer
            heightOffset={heightOffset}
            visible={props.isLegendActive}
          >
            <ViewLegend
              {...legendProps}
              labels={getViewLegendLabels(i18nLocale)}
            />
          </ViewLegendContainer>
        )}
      </HeightOffset>
    </>
  );
});

export { ArdoqGraphComponentWithLegend };
